module.exports = __webpack_public_path__ + "static/img/strona_029.c307d0e5.jpg";